import elementFromJson from "../library/deserialize";

import { FunctionalMap } from "./objectUtils";

const toJson: (data: DataState) => string = data => {
	const library = Array.from(data.elements.values()).map(elt => elt.toJson());
	const containers: ContainerS[] = Array.from(data.containers.values()).map(container => {
		const convertedContainer = toContainerS(container);

		container.content.forEach(elementId => {
			const ref = data.elementsInContainers.get(elementId);
			const eltIndex = library.findIndex(({ id }) => elementId === id);
			if (eltIndex >= 0 && ref) {
				const element = library.splice(eltIndex, 1)[0];
				convertedContainer.content.push({ ...element, pos: ref.position });
			} else {
				console.error(
					`Cound not found element ${elementId} in library for container ${container.id}. Ignoring it...`
				);
			}
		});
		return convertedContainer;
	});

	return JSON.stringify({ containers, library });
};

const fromJson: (data: string) => DataState = str => {
	const parsed: RootS = JSON.parse(str);
	const elements = new FunctionalMap<string, ElementDefinitionType>();
	const elementsInContainers = new FunctionalMap<string, ContainerElementRef>();
	parsed.library.forEach(elt => {
		const element = elementFromJson(elt);
		elements.set(element.id, element);
	});
	const containers = new FunctionalMap<string, ContainerType>();
	parsed.containers.forEach(container => {
		const convertedContainer = fromContainerEmptyS(container);
		container.content.forEach(element => {
			elements.set(element.id, elementFromJson(element));
			elementsInContainers.set(element.id, {
				elementId: element.id,
				containerId: container.id,
				position: element.pos
			});
			convertedContainer.content.push(element.id);
		});
		containers.set(convertedContainer.id, convertedContainer);
	});
	return { containers, elements, elementsInContainers };
};

export { toJson, fromJson };

/**
 * Internal serialization functions
 */

/* Serializer to Json */
const toContainerS: (cnt: ContainerType) => ContainerS = ({ content, ...cntProps }) => ({
	...cntProps,
	content: []
});

/* Deserializer from Json */
const fromContainerEmptyS: (cnt: ContainerS) => ContainerType = ({ content, ...cntProps }) => ({
	...cntProps,
	content: []
});
